<template>
  <v-app>
    <Master />
  </v-app>
</template>

<script>
import Master from "../src/components/layouts/Master.vue";
export default {
  name: "App",
  metaInfo() {
    return {
      title:
        "SaaS Pricing Pages - The worlds #1 collection of SaaS Pricing Pages"
    }
  },
  components: {
    Master
  },
  data() {
    return {
      //
    };
  }
};
</script>

<style>
body .v-application {
  font-family: "Poppins", sans-serif;
}
</style>
